<template>
  <div class="home">
    <b-container>
      <p style="color: white">
        If people haven't been online since 11.08.2020 they won't be listed
        here. Because of new API changes since Crucible, I am not allowed to
        connect new characters and accounts here.
      </p>
      <div>
        <b-form-group>
          <b-form-radio-group
            id="btn-radios-1"
            v-model="selected"
            :options="options"
            buttons
            name="radios-btn-default"
          ></b-form-radio-group>
        </b-form-group>
      </div>

      <div>
        <b-form @submit="onSubmit">
          <b-form-group id="input-group-1" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="search"
              required
              placeholder="Enter name"
            ></b-form-input>
          </b-form-group>
          <b-form-invalid-feedback :state="validation">
            Couldn't find that name.
          </b-form-invalid-feedback>
        </b-form>
      </div>

      <div id="responseArea" v-if="found">
        <b-card v-if="found" bg-variant="dark" class="text-light">
          <b-card-text v-if="selected == 'character'"
            >This character belongs to {{ response.name }}.</b-card-text
          >
          <h4>Characters:</h4>
          <br />

          <b-row v-if="response.chars && response.chars.length > 0">
            <b-col v-for="account in response.chars" :key="account.id" cols="4">
              <b-card
                bg-variant="dark"
                class="text-light h-100"
                border-variant="success"
              >
                <b-card-text>
                  Name: {{ account.name }}
                  <br />
                  Found: {{ formatDate(account.found) }}
                  <br />
                  Last seen: {{ formatDate(account.seen) }}
                  <br />
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
export default {
  name: "Account",
  components: {},
  data() {
    return {
      search: "",
      selected: "account",
      options: [
        { text: "Account", value: "account" },
        { text: "Character", value: "character" },
      ],
      found: false,
      response: {},
      valid: true,
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      if (this.search != "") {
        this.request(this.search);
      }
    },
    request(name) {
      this.found = false;
      if (this.selected == "account") {
        axios
          .get("https://api.poe.watch/account?name=" + name)
          .then((acc) => {
            if (acc.status == 200) {
              this.response = acc.data;
              this.found = true;
              this.valid = true;
            }
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.valid = false;
            }
          });
      }
      if (this.selected == "character") {
        axios
          .get("https://api.poe.watch/char?name=" + name)
          .then((acc) => {
            if (acc.status == 200) {
              this.response = acc.data;
              this.found = true;
              this.valid = true;
            }
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.valid = false;
            }
          });
      }
    },
    formatDate(date) {
      var d = new Date(date);
      var curr_date = d.getDate();
      var curr_month = d.getMonth() + 1; //Months are zero based
      var curr_year = d.getFullYear();
      var time =
        d.getUTCHours() +
        ":" +
        d.getUTCMinutes() +
        ":" +
        d.getUTCSeconds() +
        "UTC";
      return curr_date + "." + curr_month + "." + curr_year + " " + time;
    },
  },
  watch: {
    selected() {
      this.response = [];
      this.found = false;
    },
  },
  computed: {
    validation() {
      return this.valid;
    },
  },
};
</script>

<style lang="scss">
#responseArea {
  // color: white;
}
</style>
